import React, { useState } from 'react';
import { Hash } from 'lucide-react';
interface SlackStepEditorProps {
  channel: string;
  message: string;
  onUpdate: (data: {
    channel: string;
    message: string;
  }) => void;
}
const SlackStepEditor: React.FC<SlackStepEditorProps> = ({
  channel,
  message,
  onUpdate
}) => {
  const [currentChannel, setCurrentChannel] = useState(channel);
  const [currentMessage, setCurrentMessage] = useState(message);
  const handleChannelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentChannel(e.target.value);
    onUpdate({
      channel: e.target.value,
      message: currentMessage
    });
  };
  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentMessage(e.target.value);
    onUpdate({
      channel: currentChannel,
      message: e.target.value
    });
  };
  return <div className="space-y-6" data-id="element-248">
      <h3 className="text-lg font-medium" data-id="element-249">Notify Slack Channel</h3>
      <div className="space-y-4" data-id="element-250">
        <div data-id="element-251">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-252">
            Slack Channel
          </label>
          <div className="relative" data-id="element-253">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-254">
              <Hash size={16} className="text-gray-400" data-id="element-255" />
            </div>
            <select value={currentChannel} onChange={handleChannelChange} className="block w-full pl-10 pr-3 py-2 bg-white border border-gray-300 rounded-md text-sm" data-id="element-256">
              <option value="#upsell-opportunities" data-id="element-257">
                #upsell-opportunities
              </option>
              <option value="#am-upsell-alerts" data-id="element-258">#am-upsell-alerts</option>
              <option value="#cs-red-flags" data-id="element-259">#cs-red-flags</option>
              <option value="#billing-alerts" data-id="element-260">#billing-alerts</option>
            </select>
          </div>
        </div>
        <div data-id="element-261">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-262">
            Message
          </label>
          <div data-id="element-263">
            <textarea value={currentMessage} onChange={handleMessageChange} className="w-full px-3 py-2 border border-gray-300 rounded-md min-h-[100px]" placeholder="Enter your Slack message..." data-id="element-264" />
            <p className="mt-1 text-xs text-gray-500" data-id="element-265">
              You can use variables like {'{{Account.Name}}'} and{' '}
              {'{{Alert.TriggerValue}}'} in your message.
            </p>
          </div>
        </div>
        <div className="p-4 border rounded-md bg-gray-50" data-id="element-266">
          <h4 className="text-sm font-medium mb-2" data-id="element-267">Message Preview</h4>
          <div className="p-3 bg-white border rounded-md whitespace-pre-wrap" data-id="element-268">
            {currentMessage}
          </div>
        </div>
      </div>
    </div>;
};
export default SlackStepEditor;